'use strict';
import angular from 'angular'

function ContractsController($rootScope, $scope, $timeout, $location, $window, objectMakerFactory, dataHolderFactory, dataRequestService, usSpinnerService, constantSettings, appSettings) {
  var self = this;
  this.splitDocumentTypes = function(arr, documentType) {
    let docTypes = {};
    for (let i = 0; i < arr.length; i++) {
      let t = arr[i][documentType];
      if (!docTypes[t]) {
        docTypes[t] = [];
      }
      docTypes[t].push(arr[i]);
    }
    return docTypes;
  };

  this.populateContractsList = function() {
    let clusteredContracts = dataHolderFactory.getClusteredContracts();
    $scope.contractsViewControl.contracts = clusteredContracts.length ? clusteredContracts : dataHolderFactory.getContracts();
      $scope.contractsViewControl.totalContractsValue = 0;
    let documentTypes = self.splitDocumentTypes($scope.contractsViewControl.contracts, 'documentType');
    $scope.contractsViewControl.contractsListSize = documentTypes.hasOwnProperty('CONTRATO') ? documentTypes.CONTRATO.length : 0;
    $scope.contractsViewControl.covenantsListSize = documentTypes.hasOwnProperty('CONVENIO') ? documentTypes.CONVENIO.length : 0;

    angular.forEach(dataHolderFactory.getContracts(), function(contract) {
      $scope.contractsViewControl.totalContractsValue += contract.amount;
    });
  };

  $rootScope.$on('updateContracts', function() {
    self.populateContractsList();
  });

  this.getDetailsForContract = function(contractId) {

    usSpinnerService.spin('spinner-1');
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionDetailContract+contractId);
    dataRequestService.getContractDetails(contractId).then(function(data) {
      usSpinnerService.stop('spinner-1');
      $rootScope.appControl.currentContract = contractId;
      dataHolderFactory.updateContractDetails(data);
      $scope.$emit('contractUpdated', data);
      $timeout(function() {
        $rootScope.appControl.showDetailsBox = true;
      }, constantSettings.fasterDelayTimeout);
    }, function(error) {
      usSpinnerService.stop('spinner-1');
      console.log(error);
    });
  };

  this.initShowingContract = function () {
    var searchObject = $location.search();
    if (searchObject.contrato) {
      var decodedContratoId = $window.atob(searchObject.contrato);
      var contrato = {id: decodedContratoId};
      $scope.selectedContract(contrato);
      $location.search('');
    }
  };

  $scope.initContractsController = function() {
    $scope.contractsViewControl = objectMakerFactory.viewObjectControlForContracts(appSettings.config.filter.documentos);
    $scope.contractsViewControl.selectedSortingOption = $scope.contractsViewControl.sortingOptions[dataHolderFactory.getSortingOptionIndex()];
    self.populateContractsList();
    self.initShowingContract();
  };

  $scope.millisecondsToUTC = function(_date) {
    var date = new Date(_date);
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds())
  };

  $scope.didSelectSorting = function(sorting) {
    dataHolderFactory.updateSortingOptionIndex(sorting.index);
  };

  $scope.selectedContract = function(contract) {
    $rootScope.appControl.showingInMap = true;
    $rootScope.appControl.showDetailsBox = false;
    $rootScope.appControl.showFloatingControl = false;
    self.getDetailsForContract(contract.id);
  };

  $scope.redirecionarPortalDocumentos = function(contract){
    $scope.$emit('setGoogleAnalyticsData',constantSettings.actionPortal + contract.id);
    window.open(location.origin + '/obrasgov-portal-documentos/#/' +  appSettings.getSource() + '/' + contract.id + '/documentos', '_blank');
  }

  $scope.getStatusColorStyle = function(color) {
    if (!color) {
      return { 'color': '#028181' };
    }
    return { 'color': color };
  };
}

ContractsController.$inject = ['$rootScope', '$scope', '$timeout', '$location','$window', 'objectMakerFactory', 'dataHolderFactory', 'dataRequestService', 'usSpinnerService',
  'constantSettings', 'appSettings'];
export default ContractsController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/contractsController.js